export const DOWNLOAD = {
  REQUEST: 'UserManual/Download/Request',
  SUCCESS: 'UserManual/Download/Success',
  FAILURE: 'UserManual/Download/Failure'
};
